<div class="list-page">
  <h2>Tagit</h2>

  <div class="tagit-kortti mat-elevation-z1">
    <div class="tagit-otsikkorivi">
      <span class="tagit-otsikko light-blue-text">Kaikki tagit ({{ tagit().length }})</span>
      <app-secondary-button (click)="lisaa()" actionId="Lisää uusi tagi" matIcon="add">Lisää tagi</app-secondary-button>
    </div>

    @if (loading()) {
      <div lemon-loading [show]="true"></div>
    } @else {
      @for (tagi of tagit(); track tagi.avain) {
        <div class="tagi-rivi" (click)="muokkaa(tagi)">
          <span class="tagi-chip" [style.background]="tagi.varit.taustavari" [style.color]="tagi.varit.varikoodi">{{ tagi.nimi }}</span>
          <span class="tagi-tayte"></span>
          @if (tagi.poistettu) {
            <span class="tagi-status poistettu" matTooltip="Poistettua tagia ei voi valita enää asiakkaille. Asiakkailla jo olevat tagit säilyvät.">Poistettu</span>
          } @else {
            <span class="tagi-status aktiivinen">Aktiivinen</span>
          }
          <app-icon-button actionId="Muokkaa tagia" matIcon="edit" matTooltip="Muokkaa tagia"></app-icon-button>
        </div>
      } @empty {
        <div class="tagit-tyhja">Yhtään tagia ei ole vielä luotu.</div>
      }
    }
  </div>

  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div style="padding-bottom: 20px; padding-left: 1em; padding-right: 1em; padding-top: 1em">
      <div>
        Tagit: <a [href]="tagitEncodedUri" target="_blank" rel="noopener">{{ tagitUri }}</a>
      </div>
    </div>
  }
</div>
